import { render, staticRenderFns } from "./CustomRoomUrl.vue?vue&type=template&id=3f6d14eb&scoped=true&"
import script from "./CustomRoomUrl.vue?vue&type=script&lang=js&"
export * from "./CustomRoomUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6d14eb",
  null
  
)

export default component.exports